import { BibliographyClass, CollectionFlag, Prefix } from '@/types'
import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface SimpleBibliographyReal {
  bibliographyClass: BibliographyClass
  prefix: Prefix
  bibliographyId: number
  searchType: SystemCode
  displayMaterialFormat: SystemCode
  displayClass: string
  displayTitle: string
  displaySubtitle: string
  displayAuthor: string
  volume: string
  volumeNumber: string
  volumeTotal: string
  volumeDateLabel: string
  volumeSpecial: string
  displayPublisher: string
  displayPublished: string
  displaySize: string
  bibliographySetId: number | null
  marcType: SystemCode
  marcNo: string
  holdingCount: number
  orderCount: number
  reserveCount: number
  collectionFlag: CollectionFlag
  isbn10: string
  isbn13: string
}

export const defaultSimpleBibliographyReal = (): SimpleBibliographyReal => ({
  bibliographyClass: BibliographyClass.Set,
  prefix: Prefix.Real,
  bibliographyId: 0,
  searchType: defaultSystemCode(),
  displayMaterialFormat: defaultSystemCode(),
  displayClass: '',
  displayTitle: '',
  displaySubtitle: '',
  displayAuthor: '',
  volume: '',
  volumeNumber: '',
  volumeTotal: '',
  volumeDateLabel: '',
  volumeSpecial: '',
  displayPublisher: '',
  displayPublished: '',
  displaySize: '',
  bibliographySetId: null,
  marcType: defaultSystemCode(),
  marcNo: '',
  holdingCount: 0,
  orderCount: 0,
  reserveCount: 0,
  collectionFlag: CollectionFlag.NotCollection,
  isbn10: '',
  isbn13: ''
})

export function SimpleBibliographyRealFromJSON(
  json: any
): SimpleBibliographyReal {
  return {
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliographyClass
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    displayMaterialFormat: exists(json, 'display_material_format')
      ? SystemCodeFromJSON(json.display_material_format)
      : defaultSystemCode(),
    displayClass: exists(json, 'display_class') ? json.display_class : '',
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    displaySubtitle: exists(json, 'display_subtitle')
      ? json.display_subtitle
      : '',
    displayAuthor: exists(json, 'display_author') ? json.display_author : '',
    volume: exists(json, 'volume') ? json.volume : '',
    volumeNumber: exists(json, 'volume_number') ? json.volume_number : '',
    volumeTotal: exists(json, 'volume_total') ? json.volume_total : '',
    volumeDateLabel: exists(json, 'volume_date_label')
      ? json.volume_date_label
      : '',
    volumeSpecial: exists(json, 'volume_special') ? json.volume_special : '',
    displayPublisher: exists(json, 'display_publisher')
      ? json.display_publisher
      : '',
    displayPublished: exists(json, 'display_published')
      ? json.display_published
      : '',
    displaySize: exists(json, 'display_size') ? json.display_size : '',
    bibliographySetId: exists(json, 'bibliography_set_id')
      ? json.bibliography_set_id
      : null,
    marcType: exists(json, 'marc_type')
      ? SystemCodeFromJSON(json.marc_type)
      : defaultSystemCode(),
    marcNo: exists(json, 'marc_no') ? json.marc_no : '',
    holdingCount: exists(json, 'holding_count') ? json.holding_count : 0,
    orderCount: exists(json, 'order_count') ? json.order_count : 0,
    reserveCount: exists(json, 'reserve_count') ? json.reserve_count : 0,
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    isbn10: exists(json, 'isbn10') ? json.isbn10 : '',
    isbn13: exists(json, 'isbn13') ? json.isbn13 : ''
  }
}
